import { openBlock as e, createElementBlock as t, createElementVNode as c } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, n = /* @__PURE__ */ c("path", {
  "fill-rule": "evenodd",
  d: "M4.824.808a.75.75 0 1 0-1.45.384C4.04 3.7 4.937 6.127 6.87 8c-1.933 1.873-2.829 4.3-3.494 6.808a.75.75 0 1 0 1.45.384c.039-.148.079-.296.12-.442h6.11l.12.442a.75.75 0 0 0 1.45-.384C11.96 12.3 11.063 9.873 9.131 8c1.932-1.873 2.829-4.3 3.494-6.808a.75.75 0 1 0-1.45-.384l-.12.442h-6.11a28.491 28.491 0 0 1-.12-.442Zm5.763 12.442a14.72 14.72 0 0 0-.617-1.5H6.03c-.23.477-.433.978-.617 1.5h5.174Zm-3.679-3h2.184A8.417 8.417 0 0 0 8 8.994a8.417 8.417 0 0 0-1.092 1.256Zm-1.495-7.5h5.174a14.724 14.724 0 0 1-.617 1.5H6.03c-.23-.477-.433-.978-.617-1.5ZM8 7.006A8.416 8.416 0 0 1 6.908 5.75h2.184c-.32.449-.68.868-1.092 1.256Z",
  "clip-rule": "evenodd"
}, null, -1), a = [
  n
];
function l(r, d) {
  return e(), t("svg", o, [...a]);
}
const s = { render: l };
export {
  s as default,
  l as render
};
